/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  z-index: 999999;
  user-select: none;

  ${props =>
    props.mobile &&
    css`
      position: fixed;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      background: rgba(0, 0, 0, 0.75);
      overflow: hidden;
    `};
`;

const PopupView = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 5px 12px 11px;
  background-color: ${props => props.theme.mainDark};

  @media (max-width: 959px) {
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
`;

const MobileContentWrapper = styled.div`
  @media (max-width: 959px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    // max-width: 480px;
    margin: 0 auto;
  }
`;

const Title = styled.h2`
  position: relative;
  margin: 0 0 11px 0;
  padding: 13px 0;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1;
  text-transform: uppercase;
  color: ${props => props.theme.accent};
  text-align: center;

  :after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    height: 0px;
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.mainSeparator};
  }
`;

type Props = {
  title: string | React.Node,
  mobile?: boolean,
  children?: React.Node
};

function Popup(props: Props) {
  return (
    <Container mobile={props.mobile}>
      <PopupView>
        <div>
          <Title>{props.title}</Title>
          <MobileContentWrapper mobile={props.mobile}>
            {props.children}
          </MobileContentWrapper>
        </div>
        {props.info}
      </PopupView>
    </Container>
  );
}

export default Popup;



// WEBPACK FOOTER //
// ./src/components/Popup/Popup.js